var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    clipPath: "url(#clip0_2407_7069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82556 0H2.06333C0.923786 0 0 0.923786 0 2.06333V6.82556C0 7.9651 0.923786 8.88889 2.06333 8.88889H6.82556C7.9651 8.88889 8.88889 7.9651 8.88889 6.82556V2.06333C8.88889 0.923786 7.9651 0 6.82556 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9367 0H13.1744C12.0349 0 11.1111 0.923786 11.1111 2.06333V6.82556C11.1111 7.9651 12.0349 8.88889 13.1744 8.88889H17.9367C19.0762 8.88889 20 7.9651 20 6.82556V2.06333C20 0.923786 19.0762 0 17.9367 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82556 11.1111H2.06333C0.923786 11.1111 0 12.0349 0 13.1744V17.9367C0 19.0762 0.923786 20 2.06333 20H6.82556C7.9651 20 8.88889 19.0762 8.88889 17.9367V13.1744C8.88889 12.0349 7.9651 11.1111 6.82556 11.1111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9367 11.1111H13.1744C12.0349 11.1111 11.1111 12.0349 11.1111 13.1744V17.9367C11.1111 19.0762 12.0349 20 13.1744 20H17.9367C19.0762 20 20 19.0762 20 17.9367V13.1744C20 12.0349 19.0762 11.1111 17.9367 11.1111Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2407_7069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavOverview);
export default __webpack_public_path__ + "static/media/nav-overview.701518324b9dbcaf577d43ab6c3f0ede.svg";
export { ForwardRef as ReactComponent };